import { BiArrowBack } from "react-icons/bi";

function ContentPreview({ contentPreview, closeModal }) {
    return (
        <>
            <div className="fixed top-0 left-0 bg-black opacity-40 w-screen h-screen"></div>
            <div className="bg-white w-2/4 h-3/4 fixed top-20 left-1/4 rounded-lg shadow bg-garyLight">
                <div className="flex flex-row-reverse items-center justify-between bg-white rounded-t-lg shadow py-1 px-4">
                    <div className="flex flex-row-reverse items-center">
                        <div className="w-10 h-10 rounded-full bg-slate-200"></div>
                        <p className="mr-2">{contentPreview.channelName}</p>
                    </div>
                    <BiArrowBack className="text-slate-400" size={21} onClick={() => closeModal("")} />
                </div>
                <div className="h89 overflow-hidden ">
                    <img src="/image/imageBG.png" className="w-full relative" />
                    <div className="absolute top-20 right-12 flex flex-col items-center">
                        <p className="t-purpleDark text-xl font-bold mb-2 text-right w-full">پیش نمایش</p>
                        <p className="text-center mb-3 bg-gray-200 text-sm text-slate-700 p-1 px-7 shadow rounded-full">1403-02-02</p>
                        <div className="bg-white shadow rounded-2xl p-4 rounded-br-none">
                            <img src="/image/image.jpg" className="w-96 border-2 border-blue-500 rounded" />
                            <p className="w-96 text-right mt-4">برای شرایط فعلی تکنولوژی مورد نیاز کاربردهای متنوع با هدف می باشد برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع می باشد</p>
                            <p className="text-slate-400 text-xs">12:10</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default ContentPreview;